module.exports = __webpack_public_path__ + "static/media/Corinthians.b013e41e.svg";